export const GRAPHQL_ERROR_CODE_OF_NOT_FOUND = 'NOT_FOUND';
